import React from 'react';

export default function IconSecurity() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 19.1366L7.9 19.1741L9.67 17.4041H10.8475V16.2266H12.025V15.0491L14.035 13.0391C15.5425 13.6241 17.305 13.3091 18.52 12.1016C20.1475 10.4741 20.155 7.83414 18.52 6.19914C16.8925 4.57164 14.245 4.57164 12.6175 6.19914C11.41 7.40664 11.1025 9.18414 11.68 10.6841L5.5375 16.8116L5.5 19.1366Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4648 9.18359C16.9826 9.18359 17.4023 8.76386 17.4023 8.24609C17.4023 7.72833 16.9826 7.30859 16.4648 7.30859C15.9471 7.30859 15.5273 7.72833 15.5273 8.24609C15.5273 8.76386 15.9471 9.18359 16.4648 9.18359Z"
        fill="currentColor"
      />
    </svg>
  );
}
